import { style } from "typestyle"

export const topicListDiv = style({
    display: "flex",
    flexDirection: "column",
    rowGap: "1rem"
})
